import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { ButtonAppearance } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { ButtonStyle } from 'common/builder/constants/ButtonStyle'
import { getParentBlock } from 'common/builder/selectors/builder/entitySelectors'

export const getButtonAppearance = (
  entity: IButton,
  builderId: string,
  state: RootState,
): ButtonAppearance => {
  const parentBlock = getParentBlock(state, builderId, entity.id)

  if (parentBlock?.buttonsStyle === ButtonStyle.TEXT) {
    return ButtonAppearance.TEXT
  }

  return ButtonAppearance.DEFAULT_CENTERED
}
